// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"styles_tooltipContainer__Yr8jy","tooltipArrow":"styles_tooltipArrow__vCyVP"};